












































import { Component, Prop, Watch } from 'vue-property-decorator';
import { IDamage } from 'admiral-core';
import { XIcon } from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { DamageApi } from '@/services/DamageApi';

@Component({
  components: {
    XIcon,
  },
})
export default class DamageArchivePopup extends mixins(BaseMixin) {
  @Prop({ required: true, type: Boolean })
  show!: boolean;

  archivedDamages: IDamage[] = [];
  isLoading = false;

  @Watch('show')
  async onShowChanged(newValue: boolean) {
    if (newValue) {
      await this.loadArchivedDamages();
    }
  }

  async loadArchivedDamages() {
    try {
      this.isLoading = true;
      const showDemo = this.$store.getters['PreferencesModule/getShowDemo'];
      const { data } = await DamageApi.getArchivedDamages(showDemo);
      this.archivedDamages = data || [];
    } catch (error) {
      console.error('Fehler beim Laden der archivierten Schäden:', error);
      this.$toastr.e('Fehler beim Laden der archivierten Schäden');
      this.archivedDamages = [];
    } finally {
      this.isLoading = false;
    }
  }

  openDamage(damage: IDamage) {
    this.$emit('open-damage', damage.id);
    this.$emit('close');
  }

  getProductName(damage: IDamage): string {
    return damage.product && damage.product.name ? damage.product.name : 'Kein Produkt';
  }
}
